<mat-expansion-panel [togglePosition]="'before'">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Public Disclosure Information
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="p-4">

        <!-- Radio button -->
        <form [formGroup]="publicDiscloseInfo">

            <div class="row my-3">
                <div class="col-md-12 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                    <button class="clear-data-button" (click)="clearData()">
                        <i class="fa fa-repeat"></i> Clear Data
                    </button>
                </div>
            </div>

            <div class="col-12 mt-1 pl-3">

                <label class="control-lbl required mt-2 label-cls">Public disclosure information in united states will
                    be kept at ? </label>
                <div class="row pt-2">
                    <mat-radio-group aria-label="Select an option" name="publicDisclInfoId"
                        formControlName="publicDisclInfoId">
                        <mat-radio-button [value]="'EMPRPRNCPLBUSPLC'">Employer principal place of
                            business</mat-radio-button>
                        <mat-radio-button [value]="'PLCEMPL'">Place of employment </mat-radio-button>
                    </mat-radio-group>
                </div>

            </div>


            <!-- Radio button -->
        </form>
    </div>

    <!-- Confirm Reset Modal -->
    <p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>